import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/domains';
import { ErrorResultHandler } from '@lib/domain-common';
import { AxiosApi, HttpStatusCode } from '@digibricks/plugin-axios';
import { FormCategory } from '../../../core';
export var FORM_CATEGORY_API = 'FORM_CATEGORY_API';
export var FormCategoryApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(FormCategoryApi, _AxiosApi);

  var _super = _createSuper(FormCategoryApi);

  function FormCategoryApi(axiosInstance) {
    var _this;

    _classCallCheck(this, FormCategoryApi);

    _this = _super.call(this, 'form-categories', axiosInstance);
    _this.axiosInstance = axiosInstance;
    return _this;
  }

  _createClass(FormCategoryApi, [{
    key: "search",
    value: function () {
      var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var jsonResponse, parsedResponseBody, formCategoryResponse;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.axiosInstance.get(this.url, {
                  params: query
                });

              case 3:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", Result.fail(parsedResponseBody.message));

              case 7:
                formCategoryResponse = parsedResponseBody.data.map(function (responseProps) {
                  return FormCategory.create(responseProps).getValue();
                });
                return _context.abrupt("return", Result.ok(formCategoryResponse));

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function search(_x) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.axiosInstance.post(this.url, input);

              case 3:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", Result.fail(parsedResponseBody.message));

              case 7:
                return _context2.abrupt("return", Result.ok(FormCategory.create(parsedResponseBody.data).getValue()));

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10]]);
      }));

      function create(_x2) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(useCaseInput) {
        var _id, _input, jsonResponse, parsedResponseBody;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _id = useCaseInput.id, _input = useCaseInput.input;
                _context3.next = 4;
                return this.axiosInstance.patch("".concat(this.url, "/").concat(_id), _input);

              case 4:
                jsonResponse = _context3.sent;
                parsedResponseBody = jsonResponse.data;

                if (!(parsedResponseBody.statusCode !== HttpStatusCode.Ok)) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return", Result.fail(parsedResponseBody.message));

              case 8:
                return _context3.abrupt("return", Result.ok());

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 11]]);
      }));

      function update(_x3) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
        var jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.axiosInstance["delete"]("".concat(this.url, "/").concat(id));

              case 3:
                jsonResponse = _context4.sent;
                parsedResponseBody = jsonResponse.data;

                if (!(parsedResponseBody.statusCode !== HttpStatusCode.Ok)) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return", Result.fail(parsedResponseBody.message));

              case 7:
                return _context4.abrupt("return", Result.ok());

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", ErrorResultHandler(_context4.t0));

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 10]]);
      }));

      function _delete(_x4) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return FormCategoryApi;
}(AxiosApi);